const PdlDetail = () => import(/* webpackChunkName: "pdl" */ "@pages/Pdl/PdlDetail.vue")
const PdlDetailInformation = () => import(/* webpackChunkName: "pdl" */ "@pages/Pdl/Detail/PdlDetailInformation.vue")
const PdlDetailLocations = () => import(/* webpackChunkName: "pdl" */ "@pages/Pdl/Detail/PdlDetailLocations.vue")
const PdlDetailEdit = () => import(/* webpackChunkName: "pdl" */ "@pages/Pdl/Detail/PdlDetailEdit.vue")

export default [
    {
        path: 'pdl/:id',
        component: PdlDetail,
        children: [
            {
                name: 'pdl.detail',
                path: '',
                component: PdlDetailInformation,
            },
            {
                name: 'pdl.edit',
                path: 'edit',
                component: PdlDetailEdit,
            },
            {
                name: 'pdl.detail.locations',
                path: 'locations',
                component: PdlDetailLocations,
            },
        ]
    },
]
